<script>
    import { apiUrl, stickyScroll, isMobile } from "@/utils";
    import BasePrice from "@main/packages/BasePrice";

    export default {
        name: "LiteCompareHeader",
        components: {
            BasePrice,
        },
        props: {
            products: {
                type: Array,
                required: true,
                default: () => [],
            },
            imagesList: {
                type: Object,
                default: () => ({}),
            },
            topMargin: Number,
            startPosition: {
                type: Number,
                default: 560,
            },
        },
        mounted() {
            this.$nextTick(() => {
                if (!isMobile(992)) {
                    window.addEventListener("scroll", this.stickyComparisonHeaderScroll);
                }
            });
        },
        beforeDestroy() {
            window.removeEventListener("scroll", this.stickyComparisonHeaderScroll);
        },
        methods: {
            stickyComparisonHeaderScroll() {
                let el = this.$refs.scrollComparison;
                let elWrap = this.$refs.scrollComparisonWrap;

                stickyScroll({
                    el,
                    elWrap,
                    topMargin: this.topMargin,
                    startPoint: this.startPosition,
                    classNameDivider: "js-stop-scroll-comparison",
                    calcWidth: false,
                });
            },
            getProductImage(product) {
                const staticImage = this.imagesList[product.slug];
                if (staticImage) {
                    return `/static/assets/lite-compare/${this.$_name}/products/${staticImage}?v=170622`;
                }
                return apiUrl(product.offers[0]?.previewImage?.medium);
            },
            apiUrl,
        },
    };
</script>

<template>
    <div class="lite-compare-header" ref="scrollComparison">
        <div class="lite-compare-header__scroll" ref="scrollComparisonWrap" data-fix-on-scroll>
            <div class="l-container">
                <div class="lite-compare-header__wrapper">
                    <router-link
                        class="lite-compare-header__item"
                        v-for="product in products"
                        :key="product.id"
                        :to="{ name: 'Product', params: { slug: product.slug } }"
                    >
                        <div class="lite-compare-header__image">
                            <img :src="getProductImage(product)" :alt="product.name" />
                        </div>

                        <div class="lite-compare-header__box">
                            <div class="lite-compare-header__name">
                                {{ product.shortName || product.name }}
                            </div>
                            <div class="lite-compare-header__price">
                                <base-price :price="product.discountPrice"></base-price>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .lite-compare-header {
        width: 100%;
        height: 62px !important;
        margin-top: -62px;
    }

    .lite-compare-header__scroll {
        left: 0;
        opacity: 0;
        width: 100%;
        background: #fff;
        border-bottom: 1px solid #d9e9ed;
        z-index: 25;

        &.fix-scroll-block {
            opacity: 1;
        }
    }

    .lite-compare-header__wrapper {
        display: flex;
        margin: 0 40px;
        padding-left: 16%;
    }

    .lite-compare-header__item {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-grow: 1;
        padding: 0 12px;

        &:hover {
            .lite-compare-header__name {
                color: var(--secondary);
            }
        }
    }

    .lite-compare-header__image {
        position: relative;
        @include box(60px);
        margin-right: 8px;
        overflow: hidden;

        img {
            max-width: 60px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }

    .lite-compare-header__name {
        margin-bottom: 6px;
        color: var(--primary-text);
        font-size: var(--lite-compare-header-name-size);
        font-weight: var(--lite-compare-header-name-weight);
        line-height: 18px;
        transition: 0.3s ease-in color;
    }

    .lite-compare-header__price {
        color: var(--primary-text);
        font-size: var(--lite-compare-header-price-size);
        font-weight: var(--lite-compare-header-price-weight);
        line-height: 20px;
    }
</style>
